import { Injectable } from "@angular/core";
import { NgxUiLoaderService } from "ngx-ui-loader";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  constructor(private ngxLoader: NgxUiLoaderService) {}

  start(name?: string, from?: string) {
    if (name) {
      this.ngxLoader.startLoader(name);
    } else {
      this.ngxLoader.start();
    }
  }

  stop(name?: string, from?: string) {
    if (name) {
      this.ngxLoader.stopLoader(name);
    } else {
      this.ngxLoader.stop();
    }
  }
}
